export default __webpack_public_path__ + "static/media/file-icon.265d08df.svg";